var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 12.0964C11.8473 12.0964 13.1047 12.0964 13.8853 11.315C14.6667 10.5344 14.6667 9.27702 14.6667 6.76302C14.6667 4.24902 14.6667 2.99169 13.8853 2.21102C13.1047 1.42969 11.8473 1.42969 9.33334 1.42969H6.66668C4.15268 1.42969 2.89534 1.42969 2.11468 2.21102C1.33334 2.99169 1.33334 4.24902 1.33334 6.76302C1.33334 9.27702 1.33334 10.5344 2.11468 11.315C2.55001 11.751 3.13334 11.9437 4.00001 12.0284",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.76302L7.5 8.09635L10 5.42969",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 12.0962C8.50934 12.0962 7.60134 12.4295 6.77267 12.8595C5.44067 13.5509 4.77467 13.8969 4.44667 13.6762C4.11867 13.4562 4.18067 12.7729 4.30534 11.4069L4.33334 11.0962",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon-06.84e8b7712ecabd9e09741959e6509150.svg";
export { ForwardRef as ReactComponent };